import React from 'react'
import { Tooltip } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { styled } from "@mui/material/styles";

const CreateButton = ({title , url}) => {
      const navigate = useNavigate();
  const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip
      {...props}
      PopperProps={{
        modifiers: [{ name: "offset", options: { offset: [0, -30] } }],
      }}
      classes={{ popper: className }}
    />
  ))(({ theme }) => ({
    [`& .MuiTooltip-tooltip`]: {
      backgroundColor: "#28326F", // Your custom background
      color: "white",
      fontSize: 14,
      borderRadius: "8px",
      padding: "6px 12px",
      top: "80% !important", // Adjust the top position
    },
  }));
  return (
       <CustomTooltip title={title} placement="top">
          <div
            onClick={() => navigate(url)}
            className="p-3 rounded-circle bg-secondary-100-hover"
            style={{
              height: "60px",
              width: "60px",
              position: "fixed",
              bottom: "90px",
              right: "20px",
              cursor: "pointer",
              display: "grid",
              placeItems: "center",
              boxShadow: "0 4px 25px #00000040",
              zIndex: "1",
            }}
          >
            <i className="icon-add_circle text-white"></i>
          </div>
        </CustomTooltip>
  )
}

export default CreateButton
